import { render, staticRenderFns } from "./ERP.vue?vue&type=template&id=9299b1ae&scoped=true&"
import script from "./ERP.vue?vue&type=script&lang=js&"
export * from "./ERP.vue?vue&type=script&lang=js&"
import style0 from "./ERP.vue?vue&type=style&index=0&id=9299b1ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9299b1ae",
  null
  
)

export default component.exports